/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateOrganizationWebhookParams,
  CreateWebhookRequestDto,
  ListOrganizationWebhooksParams,
  OrganizationWebhookDto,
  OrganizationWebhookWithSecretDto,
  UpdateWebhookRequestDto
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListOrganizationWebhooksUrl = (params: ListOrganizationWebhooksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/webhooks?${stringifiedParams}` : `/webhooks`
}

export const listOrganizationWebhooks = async (params: ListOrganizationWebhooksParams, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationWebhookDto[]> => {

  return customFetch<OrganizationWebhookDto[]>(getListOrganizationWebhooksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrganizationWebhooksQueryKey = (params?: ListOrganizationWebhooksParams,) => {
    return [
    `/webhooks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrganizationWebhooksQueryOptions = <TData = Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError = unknown>(params: ListOrganizationWebhooksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganizationWebhooksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizationWebhooks>>> = ({ signal }) => listOrganizationWebhooks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganizationWebhooksQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganizationWebhooks>>>
export type ListOrganizationWebhooksQueryError = unknown


export function useListOrganizationWebhooks<TData = Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError = unknown>(
 params: ListOrganizationWebhooksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationWebhooks>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationWebhooks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationWebhooks<TData = Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError = unknown>(
 params: ListOrganizationWebhooksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationWebhooks>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationWebhooks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationWebhooks<TData = Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError = unknown>(
 params: ListOrganizationWebhooksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListOrganizationWebhooks<TData = Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError = unknown>(
 params: ListOrganizationWebhooksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationWebhooks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganizationWebhooksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateOrganizationWebhookUrl = (params: CreateOrganizationWebhookParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/webhooks?${stringifiedParams}` : `/webhooks`
}

export const createOrganizationWebhook = async (createWebhookRequestDto: CreateWebhookRequestDto,
    params: CreateOrganizationWebhookParams, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationWebhookWithSecretDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<OrganizationWebhookWithSecretDto>(getCreateOrganizationWebhookUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createWebhookRequestDto)
  }
);}





export const getCreateOrganizationWebhookMutationKey = () => ['createOrganizationWebhook'] as const;

export const getCreateOrganizationWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganizationWebhook>>, TError,CreateOrganizationWebhookMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganizationWebhook>>, TError,CreateOrganizationWebhookMutationVariables, TContext> => {

const mutationKey = getCreateOrganizationWebhookMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganizationWebhook>>, CreateOrganizationWebhookMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  createOrganizationWebhook(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganizationWebhook>>>
    export type CreateOrganizationWebhookMutationBody = CreateWebhookRequestDto
    export type CreateOrganizationWebhookMutationError = unknown
    export type CreateOrganizationWebhookMutationVariables = {data: CreateWebhookRequestDto;params: CreateOrganizationWebhookParams}

    export const useCreateOrganizationWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganizationWebhook>>, TError,CreateOrganizationWebhookMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrganizationWebhook>>,
        TError,
        CreateOrganizationWebhookMutationVariables,
        TContext
      > => {
      return useMutation(getCreateOrganizationWebhookMutationOptions(options), queryClient);
    }
    export const getGetOrganizationWebhookUrl = (id: string,) => {




  return `/webhooks/${id}`
}

export const getOrganizationWebhook = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationWebhookDto> => {

  return customFetch<OrganizationWebhookDto>(getGetOrganizationWebhookUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationWebhookQueryKey = (id: string,) => {
    return [
    `/webhooks/${id}`
    ] as const;
    }


export const getGetOrganizationWebhookQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationWebhook>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationWebhookQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationWebhook>>> = ({ signal }) => getOrganizationWebhook(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationWebhook>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationWebhookQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationWebhook>>>
export type GetOrganizationWebhookQueryError = unknown


export function useGetOrganizationWebhook<TData = Awaited<ReturnType<typeof getOrganizationWebhook>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationWebhook>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationWebhook>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationWebhook>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationWebhook<TData = Awaited<ReturnType<typeof getOrganizationWebhook>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationWebhook>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationWebhook>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationWebhook>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationWebhook<TData = Awaited<ReturnType<typeof getOrganizationWebhook>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganizationWebhook<TData = Awaited<ReturnType<typeof getOrganizationWebhook>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationWebhookQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateOrganizationWebhookUrl = (id: string,) => {




  return `/webhooks/${id}`
}

export const updateOrganizationWebhook = async (id: string,
    updateWebhookRequestDto: UpdateWebhookRequestDto, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationWebhookDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<OrganizationWebhookDto>(getUpdateOrganizationWebhookUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateWebhookRequestDto)
  }
);}





export const getUpdateOrganizationWebhookMutationKey = () => ['updateOrganizationWebhook'] as const;

export const getUpdateOrganizationWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationWebhook>>, TError,UpdateOrganizationWebhookMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationWebhook>>, TError,UpdateOrganizationWebhookMutationVariables, TContext> => {

const mutationKey = getUpdateOrganizationWebhookMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationWebhook>>, UpdateOrganizationWebhookMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrganizationWebhook(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationWebhook>>>
    export type UpdateOrganizationWebhookMutationBody = UpdateWebhookRequestDto
    export type UpdateOrganizationWebhookMutationError = unknown
    export type UpdateOrganizationWebhookMutationVariables = {id: string;data: UpdateWebhookRequestDto}

    export const useUpdateOrganizationWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationWebhook>>, TError,UpdateOrganizationWebhookMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationWebhook>>,
        TError,
        UpdateOrganizationWebhookMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOrganizationWebhookMutationOptions(options), queryClient);
    }
    export const getDeleteOrganizationWebhookUrl = (id: string,) => {




  return `/webhooks/${id}`
}

export const deleteOrganizationWebhook = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteOrganizationWebhookUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOrganizationWebhookMutationKey = () => ['deleteOrganizationWebhook'] as const;

export const getDeleteOrganizationWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationWebhook>>, TError,DeleteOrganizationWebhookMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationWebhook>>, TError,DeleteOrganizationWebhookMutationVariables, TContext> => {

const mutationKey = getDeleteOrganizationWebhookMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganizationWebhook>>, DeleteOrganizationWebhookMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteOrganizationWebhook(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganizationWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganizationWebhook>>>

    export type DeleteOrganizationWebhookMutationError = unknown
    export type DeleteOrganizationWebhookMutationVariables = {id: string}

    export const useDeleteOrganizationWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationWebhook>>, TError,DeleteOrganizationWebhookMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrganizationWebhook>>,
        TError,
        DeleteOrganizationWebhookMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOrganizationWebhookMutationOptions(options), queryClient);
    }
